import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import Link from 'components/basic/Link/Link';
import Tooltip from 'components/basic/tooltip/Tooltip';

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const StyledTooltip = styled(Tooltip)`
  position: relative;
  top: 1px;
  font-size: 1em;
  margin-left: 3px;
  margin-right: 3px;

  .isMobileStyle & {
    top: 2px;
  }
`;

function MoreInfoTooltip({
  children,
  tooltip,
  href,
}: {
  children?: React.ReactNode;
  tooltip?: string | undefined;
  href?: string;
}) {
  if (!tooltip) {
    return <>{children}</>;
  }
  return (
    <Wrapper>
      {children}
      <StyledTooltip
        wrapper="inlineDiv"
        text={tooltip}
        // tooltipProps={{ effect: 'solid', html: true, clickable: true }}
        pointer
      >
        {href ? (
          <Link href={href} color="white">
            <MaterialSymbol icon="info" fontSize="inherit" />
          </Link>
        ) : (
          <MaterialSymbol icon="info" fontSize="inherit" />
        )}
      </StyledTooltip>
    </Wrapper>
  );
}

export default MoreInfoTooltip;
